var _defs, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGifsmosVLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 845 278",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{font-family:sans-serif;letter-spacing:0.2em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gifsmos-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "translate(-155 -361)",
    d: "m219 498c0-72 59-131 131-131 40 0 78 18 103 49l-38 26c-3.8-3.6-32-30-71-25-37 5.4-72 38-70 81 1.4 46 46 77 77 77a83 83 0 0 0 39-10c5.1-2.8 11-6 16-12 12-15 9.7-33 8.8-39l-224-132a4.8 4.8 0 0 1 0.82-2.8 4.8 4.8 0 0 1 1.9-1.6q106 38 217 87 25 11 49 22v87l-6 7.3a130 130 0 0 1-103 50c-72 0-131-59-131-131z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "translate(-155 -361)",
    d: "m492 370h51v254h-51z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "translate(-155 -361)",
    d: "m576 370h158v51h-106v54h79v51h-79v98h-51z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "translate(-155 -361)",
    d: "m155 361 35 43c-0.67-0.89-11-15-4.1-27 6.4-12 23-11 24-11z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    x: 490,
    y: 262.24316,
    style: {
      fontSize: 50
    }
  }, "SMOS"), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m839 9-92 254h-45l-92-254h36l80 223 80-223z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifsmosVLogo);
export default __webpack_public_path__ + "static/media/gifsmos-v-logo.65c08e915324393cd55bb650a37fd200.svg";
export { ForwardRef as ReactComponent };